module.exports = __webpack_public_path__ + "media/images/bg/patterns/squares-3bea4fd36fd4cccb34ac3e2853b469b0.svg";